import { CircularProgress } from "@material-ui/core";
import React from "react";

export default function BetterButton(props) {
	return (
		<button {...props} disabled={props.loading || props.disabled}>
			{(props.loading && !props.noCircular) ? <CircularProgress color="#fff" size={16} /> : (<>{props.children}</>)}
		</button>
	)
}